var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getArgFromUrl } from './index';
var Translator = /** @class */ (function () {
    function Translator() {
        this.lang = getArgFromUrl('language') || 'en';
        this.langMap = {};
    }
    Translator.prototype.setLang = function (key, value) {
        this.langMap[key] = value;
    };
    Translator.prototype.setMultipleLangs = function (langConfigs) {
        var _this = this;
        langConfigs.forEach(function (_a) {
            var key = _a.key, value = _a.value;
            _this.setLang(key, value);
        });
    };
    Translator.prototype.get = function (key) {
        var _a, _b;
        // 首先尝试获取当前语言的翻译
        var currentLangTranslation = (_a = this.langMap[this.lang]) === null || _a === void 0 ? void 0 : _a[key];
        if (currentLangTranslation) {
            return currentLangTranslation;
        }
        // 如果当前语言没有翻译，回退到英语
        var englishTranslation = (_b = this.langMap['en']) === null || _b === void 0 ? void 0 : _b[key];
        if (englishTranslation) {
            return englishTranslation;
        }
        // 如果英语也没有翻译，返回原始key
        return key;
    };
    return Translator;
}());
var lang = new Translator();
export default lang;
export function _T(txt) {
    return lang.get(txt);
}
export function sprintf(txt, obj) {
    var result = txt;
    Object.keys(obj).forEach(function (key) {
        result = result.replace("{".concat(key, "}"), obj[key]);
    });
    return result;
}
export function setMultipleLangs(langConfigs) {
    return lang.setMultipleLangs(langConfigs);
}
export function setLangsFromModules(langModules) {
    var langConfigs = Object.entries(langModules).map(function (_a) {
        var modulePath = _a[0], value = _a[1];
        // 从模块路径中提取语言代码，例如 './lang/lang.en.json' -> 'en'
        var match = modulePath.match(/lang\.([a-z]{2})\.json$/);
        var key = match ? match[1] : modulePath;
        return { key: key, value: value };
    });
    return lang.setMultipleLangs(langConfigs);
}
export function autoLoadLangs(langContext) {
    // 动态导入所有语言文件
    var langModules = {};
    langContext.keys().forEach(function (key) {
        langModules[key] = langContext(key);
    });
    return setLangsFromModules(langModules);
}
// 自动加载语言包 (Vite版本)
export function loadLanguagesVite(langModules) {
    return __awaiter(this, void 0, void 0, function () {
        var langConfigs, _a, _b, _c, _i, path, mod, match, langCode, error_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    langConfigs = [];
                    _a = langModules;
                    _b = [];
                    for (_c in _a)
                        _b.push(_c);
                    _i = 0;
                    _d.label = 1;
                case 1:
                    if (!(_i < _b.length)) return [3 /*break*/, 4];
                    _c = _b[_i];
                    if (!(_c in _a)) return [3 /*break*/, 3];
                    path = _c;
                    return [4 /*yield*/, langModules[path]()];
                case 2:
                    mod = _d.sent();
                    match = path.match(/lang\.([a-z]{2})\.json$/);
                    langCode = match ? match[1] : path;
                    langConfigs.push({
                        key: langCode,
                        value: mod.default,
                    });
                    _d.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    // 设置语言包
                    setMultipleLangs(langConfigs);
                    console.log('Languages loaded:', langConfigs.map(function (c) { return c.key; }).join(', '));
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _d.sent();
                    console.error('Failed to load languages:', error_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
